module.exports = __webpack_public_path__ + "img/thumbnail_StandardDonkey_f_normal.895173bf.png";